const FUSED_RIGHT_ACTION_TYPES = new Set([
  'TEXT',
  'PASSWORD',
  'TEXTAREA',
  'COMBOBOX',
  'LISTBOX',
  'DATE',
  'DATETIME',
  'DATERANGE',
  'DIRECTORY',
  'MULTISELECT',
])

/** Icon-only right actions as separate squares (tiles/HTML). Not TEXT lookup fused to the field. */
export function shouldSplitStandaloneIconActionRow(options: {
  elementType?: string | null
  inTilesRow?: boolean
}): boolean {
  const type = String(options.elementType ?? '').trim().toUpperCase()
  if (FUSED_RIGHT_ACTION_TYPES.has(type)) return false
  if (options.inTilesRow) return true
  return type === 'HTML'
}
